import React, { useState } from "react";
import { GoogleLogin } from "react-google-login";
import jwtDecode from "jwt-decode";
import { postRequest } from "../../Services/axios.service";
import { toast, ToastContainer } from "react-toastify";
import { LOGIN } from "../../Utils/url.api";
import { useNavigate } from "react-router-dom";
import useUser from "../../Context/hook/useUser";
import { FcGoogle } from "react-icons/fc";
import { useEffect } from "react";
import { gapi } from "gapi-script";
import { fakepostRequest } from "../../Services/fake.service";

export const GoogleSingIn = ({
  type = "icon",
  theme = "filled_blue",
  text,
  setLogged,
  ...props
}) => {
  const navigate = useNavigate();
  const { login, getUser } = useUser();

  useEffect(() => {
    /* gapi.load('client:auth2', function() {
      // Load the client library
      gapi.client.load('apiName', 'apiVersion', function() {
        // Initialize the client library
        gapi.client.init({
          apiKey: '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',
          clientId: process.env.REACT_APP_CLIENT_ID,
          discoveryDocs: [],
          scope: '',
        }).then(function() {
          // Do something after the client library is initialized
        });
      });
    }); */
    // const initClient = () => {
    //   gapi.client.init({
    //     clientId: process.env.REACT_APP_CLIENT_ID,
    //     scope: "openid",
    //   });
    // };
    // gapi.load("client", initClient());
  }, []);

  const logWithGoogle = (credential) => {
  
    const { profileObj } = credential;
    if (profileObj?.email && profileObj?.googleId && profileObj?.name) {
      const newUser = {
        email: profileObj.email,
        fullName: profileObj.name,
        googleId: profileObj.googleId,
        userImage: profileObj.imageUrl,
      };
      tryLogin(newUser);
    }
  };

  const tryLogin = async ({ email, googleId, fullName, userImage }) => {
    toast
      .promise(postRequest(LOGIN, { googleId, email }), {
        pending: {
          position: "top-center",
          type: "default",
          isLoading: true,
          icon: false,
          render: () => "Espere",
        },
      })
      .then(({ data }) => {
        if (data?.statusCode == 401 && data?.notRegistered) {
          setTimeout(() => {
            navigate("/login/sign-google", {
              state: { email, googleId, fullName },
            });
          }, 1000);
        }
        if (data?.accessToken) {
          const { accessToken, expireAt } = data;
          login(accessToken, expireAt);
          const decode = jwtDecode(accessToken);
          if (decode?.EmailVerify == "0") {
            navigate("/verify");
          } else {
            setLogged((log) => true);
            localStorage.setItem("userImage", userImage);
          }
        }
      });
  };

  return (
    <>
      <ToastContainer />
      {/* {text ? text : ''} */}
      <GoogleLogin
        clientId={process.env.REACT_APP_CLIENT_ID}
        render={(renderProps) => (
          <button
            className="rounded-xl border py-2"
            onClick={renderProps.onClick}
          >
            <FcGoogle className="icono inline" />
            <span className="mx-8 text-xl font-medium text-font-muted">
              Iniciar con Google
            </span>
          </button>
        )}
        onFailure={logWithGoogle}
        onSuccess={logWithGoogle}
        cookiePolicy="single_host_origin"
        isSignedIn={false}
      />
    </>
  );
};
